import { render, staticRenderFns } from "./BackToMenuButton.vue?vue&type=template&id=7e0b64cd&"
import script from "./BackToMenuButton.vue?vue&type=script&lang=ts&"
export * from "./BackToMenuButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports